import type {OptionTypeWithLabel} from './functions/types';

const CollectionLegend = ({options}: {options: OptionTypeWithLabel[]}) => {
    const groups = options.filter(
        group => group.label !== 'Last used' && group.options.length > 0
    );

    if (groups.length === 0) return null;

    return (
        <ul className="problem-add-to-legend">
            {groups.map(group => (
                <li key={group.label}>
                    <span
                        className="problem-add-to-legend-swatch"
                        style={{backgroundColor: group.options[0].color}}
                        aria-hidden="true"
                    />
                    <span>{group.label}</span>
                </li>
            ))}
        </ul>
    );
};

export default CollectionLegend;
